<template>
  <div class="page-container has-action">
    <van-nav-bar fixed title="在线支付" left-arrow @click-left="goableBack()" />
    <div class="payment payment_1">
      <!-- 买入金额 -->
      <div v-show="false">
        <van-cell-group title="买入金额">
          <div class="tian-amount van-cell van-field">
            <div class="van-field__left-icon">￥</div>
            <div class="van-cell__value">
              <div class="van-field__body">
                <input
                  v-model="payForm.amount"
                  disabled
                  type="text"
                  placeholder="10,000元起"
                  class="van-field__control" />
              </div>
            </div>
          </div>
          <div class="tian-amount-desc">
            <span>10月1日开始产生收益，12月12日收益到账</span>
          </div>
        </van-cell-group>
        <div style="height: 8px; background-color: #f1f5f8"></div>
      </div>
      <div class="block">
        <van-field
          v-model="bankCard"
          readonly
          clearable
          input-align="right"
          label="银行卡"
          placeholder="请选择银行卡"
          @click="bankPicker.show = true"
          right-icon="arrow-down" />
      </div>
    </div>
    <div class="page-action">
      <van-button
        class="payment-next-step"
        @click="onClickNext"
        type="danger"
        size="large"
        >确定</van-button
      >
    </div>
    <van-popup v-model="bankPicker.show" position="bottom">
      <van-picker
        show-toolbar
        value-key="tailTag"
        :columns="bankPicker.columns"
        :loading="bankPicker.loading"
        @cancel="bankPicker.show = false"
        @confirm="confirmBankPicker" />
    </van-popup>
    <bl-eft
      v-model.sync="eftShow"
      :payType="payType"
      title="金额超出上限 请使用线下转账"></bl-eft>
  </div>
</template>

<script>
import * as PayApi from "@/api/pay"
import * as CustApi from "@/api/cust"
import * as ProductApi from "@/api/product"
import BlEft from "@/components/bl-eft"
import "./idx.less"
import {
  Tag,
  Col,
  NavBar,
  Button,
  Cell,
  CellGroup,
  RadioGroup,
  Radio,
  Toast,
  Dialog,
  Field,
  Checkbox,
  Popup,
  Picker,
  Icon
} from "vant"

export default {
  components: {
    BlEft,
    [Tag.name]: Tag,
    [Col.name]: Col,
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Icon.name]: Icon
  },

  data() {
    return {
      bankCard: "",
      //  用户选择银行卡
      bankPicker: {
        show: false,
        loading: false,
        columns: []
      },
      payForm: {
        tradeAmount: "",
        productId: "", //  开户行名, 例如: 中国银行
        fundOutType: "",
        terminal: "H5", // 终端
        bindCardId: "" // 用户选择的银行卡的银行id
      },
      eftShow: false,
      payType: {}
    }
  },

  created() {
    this.payForm.tradeAmount = this.$route.query.tradeAmount
    this.payForm.productId = this.$route.query.productId
    this.payForm.fundOutType = this.$route.query.fundOutType
    this.getBankList()
    PayApi.paytype()
      .then((data) => {
        this._dismissLoading()
        this.payType = data
      })
      .catch((e) => {
        this._dismissLoading()
        Toast(e.msg || e.message)
      })
  },

  methods: {
    getBankList() {
      this.bankPicker.loading = true
      CustApi.listBindCard()
        .then((data) => {
          this.bankPicker.columns = data || []
          this.bankPicker.loading = false

          if (data && data.length) {
            this.payForm.bindCardId = data[0].id
            this.bankCard = data[0].tailTag
          }
        })
        .catch((e) => {
          Toast(e.msg || e.message)
        })
    },

    onClickNext() {
      if (!this.payForm.bindCardId) {
        Toast("请选择银行卡")
        return
      }
      this._showLoading()
      ProductApi.canbuy(this.payForm.productId)
        .then((data) => {
          if (data.canBuy) {
            PayApi.getpayurl(this.payForm)
              .then((data) => {
                location.href = data
              })
              .catch((e) => {
                this._dismissLoading()
                if (e.code == 2006) {
                  this.eftShow = true
                  return
                } else {
                  Toast(e.msg || e.message)
                }
              })
          } else {
            this._dismissLoading()
            Toast({
              message: data.msg || "资产已抢光",
              onClose: function () {
                this.$router.push({
                  name: "invest"
                })
              }
            })
          }
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
        })
    },

    // 确认选择银行卡
    confirmBankPicker(value) {
      this.bankCard = value.tailTag
      this.payForm.bindCardId = value.id
      this.bankPicker.show = false
    }
  }
}
</script>

<style lang="less" scoped>
.payment_1 {
  .bank_name {
    line-height: 1;
    font-size: 12px;
    text-align: right;
  }
  .bank_quota {
    color: rgb(159, 173, 174);
    font-size: 10px;
    width: 140px;
    display: inline-block;
    line-height: 1;
    margin-top: 4px;
    margin-right: -10px;
  }
}
</style>
